import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export class CustomValidators {

    public static matchValidator(firstControlName: string, secondControlName: string, errorMessage: string): ValidatorFn {

        return (control: AbstractControl): ValidationErrors | null => {

            const firstControlValue = control.get(firstControlName)?.value;
            const secondControlValue = control.get(secondControlName)?.value;
            if (firstControlValue && secondControlValue && firstControlValue != secondControlValue) {
                return { [errorMessage]: true }
            }

            return null;
        }
    }

    public static oneFilledOthersAreRequired(controlNames: string[], errorMessage: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {

            let oneFilled: boolean = false;
            let allFilled: boolean = true;

            controlNames.forEach((controlName) => {
                const value = control.get(controlName)?.value;
                if (value && value.trim().length > 0) {
                    oneFilled = true;
                } else {
                    allFilled = false;
                }
            });

            if (oneFilled && !allFilled) {
                return { [errorMessage]: true }
            }

            return null;
        }
    }

    public static patternWithMessage(pattern: string, errorMessage: string): ValidatorFn {

        return (control: AbstractControl): ValidationErrors | null => {
            const patternValidatorFunction = Validators.pattern(pattern)
            if (patternValidatorFunction(control) === null) {
                return null;
            } else {
                return { [errorMessage]: true }
            }
        }
    }

    public static selectRequired(control: AbstractControl): { [key: string]: any } | null {
        const selectValue = control.value;
        if (!selectValue || selectValue.toString() == "0") {
            return { 'required': true }
        } else {
            return null;
        }
    }
    public static MinimumDateIsOk(minDate: Date): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) return null;

            const controlDate = new Date(control.value);
            if (isNaN(controlDate.getTime())) return { invalidDate: true };

            controlDate.setHours(0, 0, 0, 0);
            const min = new Date(minDate);
            min.setHours(0, 0, 0, 0);

            if (controlDate < min) {
                return { minDate: true };
            }

            return null;
        };

  }
}
